<div class="preview-template-v1-wrapper">
  <h2 mat-dialog-title class="preview-template-v1-wrapper__title">
    {{ 'CHAT.POPUP.TEMPLATE.PREVIEW' | translate }}
  </h2>

  <div class="preview-template-v1-wrapper__content">
    <preview-template [template]="data.template"></preview-template>
  </div>

  <div mat-dialog-actions class="preview-template-v1-wrapper__actions">
    <button mat-button (click)="matDialogRef.close()">CERRAR</button>
  </div>
</div>
